export const SET_CASH_DRAWER_CONFIG = 'SET_CASH_DRAWER_CONFIG'
